import axios from 'axios';

// Beneficios (propuesta integral Fase 3). baseURL ya incluye /{tenant}/.
export default {
  listDefinitions(tier) {
    return axios.get('/benefit-definitions', { params: tier ? { tier } : {} });
  },
  createDefinition(data) {
    return axios.post('/benefit-definitions', data);
  },
  updateDefinition(id, data) {
    return axios.put(`/benefit-definitions/${id}`, data);
  },
  deleteDefinition(id) {
    return axios.delete(`/benefit-definitions/${id}`);
  },
  evaluate(payload) {
    return axios.post('/benefits/evaluate', payload);
  },
  issue(payload) {
    return axios.post('/benefits/issue', payload);
  },
  customerBenefits(customerId) {
    return axios.get(`/customers/${customerId}/benefits`);
  },
  revoke(id) {
    return axios.post(`/customer-benefits/${id}/revoke`);
  },
  extend(id, expiresAt) {
    return axios.post(`/customer-benefits/${id}/extend`, { expires_at: expiresAt });
  }
}
